<template>
  <IdentifyConfirm
    top-page-id="mb038"
    previous-page-id="mb035"
    next-page-id="mb037"
  >
    <template #wizard>
      <MainWizard :active-index="2" type="useridentity"></MainWizard>
    </template>
  </IdentifyConfirm>
</template>

<script>
import { setMeta } from "@/utils/Meta";
import MainWizard from "@/components/wizard/MainWizard";
import IdentifyConfirm from "@/components/fileupload/IdentifyConfirm";

export default {
  name: "Mb036",
  components: {
    IdentifyConfirm,
    MainWizard,
  },
  setup() {
    setMeta({
      title: "ご本人さま確認書類のご提出",
      description:
        "au PAY スマートローンはau IDをお持ちのお客様のための便利なカードレスローンサービスです。お申込みは、スマートフォン・パソコンでかんたんWEB完結！24時間お申込み可能。最短30分で審査結果をご連絡します。",
      keywords:
        "au PAY スマートローン,au,カードレスローン,スマートフォン,au PAY 残高,セブン銀行スマホATM,借入,返済,手続き,会員,会員サイト,本人確認書類",
    });
  },
};
</script>

<style scoped></style>
